/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import Modal from './index';
import style from './modal.module.scss';
import Button from 'controls/buttons/submit';
import { useSearchControl } from 'hooks/useSearchControl';
import { Resource } from 'store/types';
import isEmpty from 'lodash-es/isEmpty';
import ErrorModal from 'components/modal/errorModal';
import { useAppDispatch } from 'store/hooks';
import { editRequest } from 'store/page/pageSlice';
import HelperSearch from 'controls/search/helperSearch/helperSearch';
import { MIN_TABLET_WIDTH } from 'utils/utils';
import { useViewport } from 'contexts/viewportContext';

export default function WarningModal({
  item,
  onCancel,
  onConfirmLoader,
}: {
  onCancel: () => void;
  item: Resource;
  onConfirmLoader?: boolean;
}) {
  const { width } = useViewport();
  const dispatch = useAppDispatch();
  const [tags, setTags] = useState(item.tags);
  const [initialTags] = useState(item.tags);
  const [disabled, setDisabled] = useState(true);
  const [currentModal, setCurrentModal] = useState<null | React.ReactElement>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);

  //   const isMobileAdaptiveModeOn = window.innerWidth < MIN_TABLET_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  useEffect(() => {
    setDisabled(JSON.stringify(initialTags) === JSON.stringify(tags));
  }, [tags]);

  const clickHandler = useCallback(() => {
    if (isEmpty(tags)) {
      setCurrentModal(
        <ErrorModal
          onClose={() => setCurrentModal(null)}
          errorText="Нельзя сохранить элемент без тегов"
        ></ErrorModal>
      );

      return;
    }

    if (onConfirmLoader) {
      setIsLoading(true);
    }

    // ts не воспринимает проверки lodash
    if (tags !== undefined) {
      dispatch(
        editRequest({
          id: item._id,
          params: {
            tags: tags,
          },
        })
      );
    }
  }, [tags, onConfirmLoader, item, disabled]);

  return (
    <Modal open={true} onClose={onCancel}>
      <div className={style.edit}>
        {currentModal !== null && currentModal}

        {isMobileAdaptiveModeOn ? (
          ''
        ) : (
          <div className={style.imageWrapper}>
            <img className={style.image} src={item.preview_link}></img>
          </div>
        )}

        <form
          className={style.rightWrapper}
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            clickHandler();
          }}
        >
          <div className={style.tags}>
            <span>Теги:</span>
            <HelperSearch
              className={style.search}
              tagsStrategy={useSearchControl.bind(null, {
                forceTags: item.tags || {},
                onUpdate: (tags) => {
                  setTags(tags);
                },
              })}
            ></HelperSearch>
          </div>
          <Button
            disabled={disabled}
            wrapper={{
              loading: isLoading,
              className: style.editButton,
            }}
            // onClick={clickHandler}
          >
            {!isLoading && 'Сохранить'}
          </Button>
        </form>
      </div>
    </Modal>
  );
}
